import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogProps,
  SxProps,
  Theme,
} from "@mui/material";
import React from "react";

export interface IDialogOption {
  title: string;
  handleOption: () => void;
  closeAfterClick?: boolean;
}

interface MissingMasspointsComponentProps {
  title: string;
  onClose: () => void;
  isOpen: boolean;
  options: Array<IDialogOption>;
  children: React.ReactNode;
  container?: HTMLElement;
  dialogSx?: SxProps<Theme>;
  instantClose?: boolean;
  transitionSlot?: NonNullable<DialogProps["slots"]>["transition"];
}

export const DialogComponent: React.FC<MissingMasspointsComponentProps> = ({
  title,
  onClose,
  isOpen,
  options,
  children,
  container,
  dialogSx,
  instantClose = false,
  transitionSlot,
}) => {
  const handleClose = () => {
    onClose();
  };

  const handleOptionAndClose = (option: IDialogOption) => {
    option.handleOption();
    if (option.closeAfterClick !== false) {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        container={container}
        disableScrollLock={!!container}
        maxWidth={false}
        sx={dialogSx}
        {...(instantClose ? {
          closeAfterTransition: false,
          slots: { transition: transitionSlot },
          slotProps: { backdrop: { transitionDuration: 0 } },
        } : {})}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

        <DialogContent>
          <DialogContentText component="div">
            <div id="alert-dialog-description">{children}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {options.map((option, index) => (
            <Button
              variant="outlined"
              key={index}
              onClick={() => handleOptionAndClose(option)}
            >
              {option.title}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </div>
  );
};
